/**
  * @class mmodEmpty
  * @description
  * Empty module displays an empty screen. It is used in some specific circumstances.
  * Module is implemented without workflow, as a pure module named mmodEmpty.
  */

import mmodModule from 'mmodModule'

export default class mmodEmpty extends mmodModule {
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates an instance of the class.
  * @param {string} [id] - ID under which the object will listen for messages
  * @param {string} [cfg] - object initial configuration
  * @param {string} [cfg_schema] - additional schema properties from derived classes
  * @param {string} [dependencies] - additional dependencies from derived classes
  */
  constructor(id, cfg, cfg_schema, dependencies) {
    dependencies = _.union([/* put module specific dependencies here */], dependencies)
    cfg_schema = _.extend({
      init: {
        type: 'object',
        default: { type: 'full' },
        description: 'Initial window setup; same structure as required by `mmWindowSet`',
      },
    }, cfg_schema)
    super(id, cfg, cfg_schema, dependencies)
  } // constructor

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * @description
  * initialization of GUI components
  */
  initWindow() {
    this.mmStart()
  } // initWindow
} // mmodEmpty
